// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parser-container {
  width: 100%;
}

.parser-header {
  padding-bottom: 1rem;
  border-bottom: 2px solid #e9ecef;
}

.parser-header h2 {
  color: #333;
  margin: 0 0 0.5rem 0;
  font-size: 1.8rem;
}

.parser-header p {
  color: #666;
  margin: 0;
  font-size: 1rem;
}

/* Loading State */
.loading-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem;
  color: #666;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #667eea;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Error State */
.error-state {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
  border-radius: 8px;
  font-weight: 500;
}

/* Animations */
.parser-container {
  animation: fadeInUp 0.6s ease-out;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Dark theme */
.dark-theme .parser-header h2 {
  color: #e9ecef;
}

.dark-theme .parser-header p {
  color: #adb5bd;
}

.dark-theme .parser-header {
  border-bottom-color: #495057;
}

/* Process steps styles */
.add-step-row {
  display: flex;
  justify-content: center;
  margin-bottom: 1.2rem;
}

.btn.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);
  color: #fff;
  border: none;
  padding: 0.6rem 1.4rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}

.btn.btn-primary:hover {
  background: linear-gradient(135deg, #2193b0 0%, #667eea 100%);
}

.process-steps-list {
  margin-top: 2rem;
  background: #f5f7fa;
  border-radius: 12px;
  padding: 1.2rem 1.5rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.steps-header {
  /* display: flex; */
  display: grid;
  grid-template-columns: auto auto 1fr;
  align-items: center;
  font-weight: 600;
  margin-bottom: 0.7rem;
  color: #333;
}

.steps-container {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin: 0;
  padding: 0;
  min-height: 60px;
  transition: all 0.3s ease;
}

.step-item {
  font-size: 1rem;
  color: #222;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #e9ecef;
  border-radius: 6px;
  border: 1px solid #dee2e6;
  padding: 0.5rem 0.8rem;
  padding-right: 25px;
  position: relative;
  min-width: 120px;
  transition: all 0.2s ease;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
}

.step-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.step-item:active {
  cursor: grabbing;
}

.step-content {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1 1;
}

.drag-handle {
  color: #999;
  font-size: 0.8rem;
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  transition: color 0.2s;
}

.drag-handle:hover {
  color: #667eea;
}

.step-item:active .drag-handle {
  cursor: grabbing;
}

.step-code {
  font-weight: 500;
}

.step-num {
  font-weight: 700;
  margin-right: 0.5rem;
  color: #2193b0;
}



.remove-step-btn {
  position: absolute;
  right: -2px;
  top: -2px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 18px;
  height: 18px;
  font-size: 10px;
  cursor: pointer;
  opacity: 0;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-item:hover .remove-step-btn {
  opacity: 1;
}

.step-item.dragging {
  transform: rotate(5deg) scale(1.05) !important;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  z-index: 1000 !important;
  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);
  color: white;
  transition: all 0.2s ease;
}

.step-item.dragging .step-num {
  color: white;
}

.step-item.dragging .remove-step-btn {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.step-item.dragging .remove-step-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.step-item.drag-over {
  border: 2px dashed #667eea;
  background: rgba(102, 126, 234, 0.1);
  transform: scale(1.02);
}

.remove-step-btn:hover {
  background: #c82333;
  transform: scale(1.1);
}

/* Анимации для перетаскивания */

.steps-container {
  transition: all 0.3s ease;
}

/* Индикатор места вставки */
.steps-container::before {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 4px;
  background: #667eea;
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;
}

.steps-container.dragging-over::before {
  opacity: 1;
}

/* Responsive Design */
@media (max-width: 700px) {
  .process-steps-list {
    padding: 0.7rem 0.5rem;
  }
  
  .add-step-row {
    justify-content: center;
  }
  
  .parser-header h2 {
    font-size: 1.5rem;
  }
}

/* Модальное окно подтверждения */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.3s ease-out;
}

.modal-content {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  animation: slideInUp 0.3s ease-out;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.5rem 0 1.5rem;
  border-bottom: 1px solid #e9ecef;
}

.modal-header h3 {
  margin: 0;
  color: #333;
  font-size: 1.3rem;
  font-weight: 600;
}

.modal-close {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #999;
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 50%;
  transition: all 0.2s;
}

.modal-close:hover {
  background: #f8f9fa;
  color: #333;
}

.modal-body {
  padding: 1.5rem;
}

.confirmation-icon {
  text-align: center;
  font-size: 3rem;
  margin-bottom: 1rem;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.1); }
}

.confirmation-text {
  text-align: center;
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 1.5rem;
  line-height: 1.5;
}

.steps-summary {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 1rem;
  margin-top: 1rem;
}

.steps-summary h4 {
  margin: 0 0 0.5rem 0;
  color: #333;
  font-size: 1rem;
  font-weight: 600;
}

.steps-preview {
  max-height: 200px;
  overflow-y: auto;
}

.step-preview-item {
  display: flex;
  align-items: flex-start;
  padding: 0.75rem 0;
  border-bottom: 1px solid #e9ecef;
  gap: 0.75rem;
}

.step-preview-item:last-child {
  border-bottom: none;
}

.step-number {
  background: #667eea;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  font-weight: 600;
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.step-details {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.step-detail-row {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.step-detail-label {
  font-weight: 600;
  color: #666;
  font-size: 0.85rem;
  min-width: 70px;
  flex-shrink: 0;
}

.step-detail-value {
  color: #333;
  font-size: 0.9rem;
  font-weight: 500;
}

.step-code {
  color: #2193b0;
  font-weight: 600;
  font-family: 'Courier New', monospace;
  font-size: 0.9rem;
  background: #f8f9fa;
  padding: 0.2rem 0.4rem;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem 1.5rem 1.5rem 1.5rem;
  border-top: 1px solid #e9ecef;
}

.modal-footer .btn {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.2s;
}

.modal-footer .btn:hover {
  transform: translateY(-1px);
}

/* Темная тема для модального окна */
.dark-theme .modal-content {
  background: #2d2d2d;
  color: white;
}

.dark-theme .modal-header h3 {
  color: white;
}

.dark-theme .modal-close {
  color: #ccc;
}

.dark-theme .modal-close:hover {
  background: #3d3d3d;
  color: white;
}

.dark-theme .confirmation-text {
  color: #ccc;
}

.dark-theme .steps-summary {
  background: #3d3d3d;
}

.dark-theme .steps-summary h4 {
  color: white;
}

.dark-theme .step-detail-label {
  color: #a0aec0;
}

.dark-theme .step-detail-value {
  color: #e2e8f0;
}

.dark-theme .step-code {
  color: #64d8e6;
  background: #4a5568;
  border-color: #667788;
}

.dark-theme .modal-header,
.dark-theme .modal-footer {
  border-color: #555;
}

.dark-theme .step-preview-item {
  border-color: #555;
}

/* Анимации для модального окна */
@keyframes slideInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Темная тема для process-steps-list */
.dark-theme .process-steps-list {
  background: #2d2d2d;
  border: 1px solid #4a5568;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.dark-theme .steps-header {
  color: #ffffff;
}

.dark-theme .step-item {
  background: #3d3d3d;
  border: 1px solid #4a5568;
  color: #e2e8f0;
}

.dark-theme .step-item:hover {
  background: #4a5568;
  color: #ffffff;
}

.dark-theme .step-num {
  color: #667eea;
}

.dark-theme .drag-handle {
  color: #a0aec0;
}

.dark-theme .drag-handle:hover {
  color: #667eea;
}

.dark-theme .step-item.dragging {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #ffffff;
}

.dark-theme .step-item.dragging .step-num {
  color: #ffffff;
}

.dark-theme .step-item.drag-over {
  border: 2px dashed #667eea;
  background: rgba(102, 126, 234, 0.2);
} 

/* Добавляем стили для предупреждения о блокировке */
.lock-warning {
  background: linear-gradient(135deg, #fed7d7 0%, #feb2b2 100%);
  border: 2px solid #fc8181;
  border-radius: 8px;
  padding: 1rem;
  margin: 1rem 0;
  text-align: center;
  color: #c53030;
  font-weight: 600;
  animation: pulse 2s infinite;
}

.dark-theme .lock-warning {
  background: linear-gradient(135deg, #742a2a 0%, #9b2c2c 100%);
  border-color: #fc8181;
  color: #fed7d7;
}

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.02); }
  100% { transform: scale(1); }
}

/* Стили для заблокированных кнопок */
.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none !important;
  box-shadow: none !important;
}

/* Стили для заблокированных элементов в DraggableSteps */
.step-item.locked {
  opacity: 0.7;
  cursor: not-allowed;
}

.step-item.locked .remove-step-btn {
  display: none;
}

.step-item.locked .drag-handle {
  cursor: not-allowed;
} 

/* Анимированная подсказка */
.animated-tooltip {
  filter: drop-shadow(0 10px 25px rgba(0, 0, 0, 0.15));
}

.tooltip-content {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 0;
  min-width: 280px;
  max-width: 320px;
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
}

.tooltip-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  animation: shimmer 2s infinite;
  pointer-events: none;
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

.tooltip-header {
  background: rgba(255, 255, 255, 0.1);
  padding: 12px 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  gap: 8px;
}

.tooltip-icon {
  font-size: 16px;
  animation: bounce 2s infinite;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-3px); }
  60% { transform: translateY(-2px); }
}

.tooltip-title {
  color: white;
  font-weight: 600;
  font-size: 14px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.tooltip-body {
  padding: 16px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 0 0 12px 12px;
}

.tooltip-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
  padding: 4px 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.tooltip-row:hover {
  background: rgba(102, 126, 234, 0.05);
  border-radius: 6px;
  padding: 4px 8px;
  margin: 0 -8px 8px -8px;
}

.tooltip-row:last-child {
  margin-bottom: 0;
  border-bottom: none;
}

.tooltip-label {
  color: #495057;
  font-weight: 600;
  font-size: 12px;
  min-width: 80px;
  flex-shrink: 0;
}

.tooltip-value {
  color: #2193b0;
  font-weight: 500;
  font-size: 12px;
  text-align: right;
  flex: 1 1;
  margin-left: 12px;
  word-break: break-word;
}

.tooltip-code {
  color: #e83e8c;
  font-family: 'Courier New', monospace;
  font-weight: 600;
  font-size: 11px;
  background: rgba(232, 62, 140, 0.1);
  padding: 2px 6px;
  border-radius: 4px;
  border: 1px solid rgba(232, 62, 140, 0.2);
  text-align: right;
  flex: 1 1;
  margin-left: 12px;
  word-break: break-all;
}

.tooltip-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

/* Стрелка для подсказки справа (указывает влево) */
.arrow-left {
  left: -8px;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 8px solid rgba(255, 255, 255, 0.95);
}

/* Стрелка для подсказки слева (указывает вправо) */
.arrow-right {
  right: -8px;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-left: 8px solid rgba(255, 255, 255, 0.95);
}

/* Темная тема для подсказки */
.dark-theme .tooltip-content {
  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);
  border-color: rgba(255, 255, 255, 0.1);
}

.dark-theme .tooltip-header {
  background: rgba(255, 255, 255, 0.05);
  border-bottom-color: rgba(255, 255, 255, 0.1);
}

.dark-theme .tooltip-body {
  background: rgba(45, 55, 72, 0.95);
}

.dark-theme .tooltip-label {
  color: #a0aec0;
}

.dark-theme .tooltip-value {
  color: #3bbedb;
}

.dark-theme .tooltip-code {
  color: #f687b3;
  background: rgba(246, 135, 179, 0.1);
  border-color: rgba(246, 135, 179, 0.2);
}

.dark-theme .tooltip-row:hover {
  background: rgba(59, 190, 219, 0.1);
}

.dark-theme .arrow-left {
  border-right-color: rgba(45, 55, 72, 0.95);
}

.dark-theme .arrow-right {
  border-left-color: rgba(45, 55, 72, 0.95);
}

/* Адаптивность для подсказки */
@media (max-width: 768px) {
  .tooltip-content {
    min-width: 240px;
    max-width: 280px;
  }
  
  .tooltip-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .tooltip-value,
  .tooltip-code {
    text-align: left;
    margin-left: 0;
  }
}

/* Анимации появления/исчезновения */
@keyframes tooltipFadeIn {
  from {
    opacity: 0;
    transform: translateY(10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes tooltipFadeOut {
  from {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateY(10px) scale(0.95);
  }
}

/* Улучшенные стили для step-item при наведении */
.step-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.2);
  border-color: #667eea;
}

.step-item:hover .step-code {
  color: #667eea;
  font-weight: 600;
}

/* Темная тема для hover эффектов */
.dark-theme .step-item:hover {
  box-shadow: 0 6px 20px rgba(59, 190, 219, 0.3);
  border-color: #3bbedb;
}

.dark-theme .step-item:hover .step-code {
  color: #3bbedb;
} 

/* Анимация фейрверка */
.fireworks-container {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 9999;
  overflow: hidden;
}

.firework {
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  animation: firework 2s ease-out infinite;
}

.firework-1 {
  left: 20%;
  top: 60%;
  background: #ff6b6b;
  animation-delay: 0s;
}

.firework-2 {
  left: 40%;
  top: 40%;
  background: #4ecdc4;
  animation-delay: 0.3s;
}

.firework-3 {
  left: 60%;
  top: 50%;
  background: #45b7d1;
  animation-delay: 0.6s;
}

.firework-4 {
  left: 80%;
  top: 30%;
  background: #96ceb4;
  animation-delay: 0.9s;
}

.firework-5 {
  left: 30%;
  top: 70%;
  background: #feca57;
  animation-delay: 1.2s;
}

.firework-6 {
  left: 70%;
  top: 60%;
  background: #ff9ff3;
  animation-delay: 1.5s;
}

.firework-7 {
  left: 50%;
  top: 80%;
  background: #54a0ff;
  animation-delay: 1.8s;
}

.firework-8 {
  left: 10%;
  top: 50%;
  background: #5f27cd;
  animation-delay: 2.1s;
}

@keyframes firework {
  0% {
    transform: translateY(0) scale(1);
    opacity: 1;
    box-shadow: 
      0 0 0 0 #ff6b6b,
      0 0 0 0 #4ecdc4,
      0 0 0 0 #45b7d1,
      0 0 0 0 #96ceb4;
  }
  50% {
    transform: translateY(-100px) scale(1.5);
    opacity: 0.8;
    box-shadow: 
      0 -20px 0 0 #ff6b6b,
      0 -40px 0 0 #4ecdc4,
      0 -60px 0 0 #45b7d1,
      0 -80px 0 0 #96ceb4;
  }
  100% {
    transform: translateY(-200px) scale(0.1);
    opacity: 0;
    box-shadow: 
      0 -40px 0 0 #ff6b6b,
      0 -80px 0 0 #4ecdc4,
      0 -120px 0 0 #45b7d1,
      0 -160px 0 0 #96ceb4;
  }
}

/* Кнопка с эффектом фейрверка */
.fireworks-trigger {
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.fireworks-trigger::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: radial-gradient(circle, rgba(255,255,255,0.8) 0%, transparent 70%);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.5s ease;
}

.fireworks-trigger:hover::before {
  width: 300px;
  height: 300px;
}

/* Модалка успеха */
.success-overlay {
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.9) 0%, rgba(118, 75, 162, 0.9) 100%);
  backdrop-filter: blur(10px);
}

.success-modal {
  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  border: 2px solid rgba(102, 126, 234, 0.3);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: successModalSlideIn 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes successModalSlideIn {
  0% {
    opacity: 0;
    transform: translateY(-50px) scale(0.9);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.success-header {
  text-align: center;
  padding: 2rem 2rem 1rem 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 12px 12px 0 0;
  position: relative;
  overflow: hidden;
}

.success-header::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  animation: shimmer 2s infinite;
}

.success-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  animation: bounce 1s ease-in-out infinite;
  display: block;
}

.success-header h3 {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.success-body {
  padding: 2rem;
  text-align: center;
}

.success-text {
  font-size: 1.3rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 1rem;
  animation: fadeInUp 0.8s ease-out 0.3s both;
}

.success-subtext {
  font-size: 1rem;
  color: #666;
  margin-bottom: 2rem;
  line-height: 1.6;
  animation: fadeInUp 0.8s ease-out 0.5s both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.success-stats {
  display: flex;
  justify-content: center;
  gap: 3rem;
  margin-bottom: 2rem;
  animation: fadeInUp 0.8s ease-out 0.7s both;
}

.stat-item {
  text-align: center;
  padding: 1rem;
  border-radius: 12px;
  border: 1px solid #dee2e6;
  min-width: 120px;
  transition: all 0.3s ease;
}

.stat-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.2);
}

.stat-number {
  display: block;
  font-size: 2rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 0.9rem;
  color: #ffffff;
  font-weight: 500;
}

.success-footer {
  display: flex;
  justify-content: center;
  gap: 1rem;
  padding: 1.5rem 2rem 2rem 2rem;
  border-top: 1px solid #e9ecef;
  animation: fadeInUp 0.8s ease-out 0.9s both;
}

.dashboard-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  font-size: 1rem;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.dashboard-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  transition: left 0.5s ease;
}

.dashboard-btn:hover::before {
  left: 100%;
}

.dashboard-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.4);
}

/* Темная тема для модалки успеха */
.dark-theme .success-modal {
  background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%);
  border-color: rgba(102, 126, 234, 0.5);
}

.dark-theme .success-text {
  color: #e2e8f0;
}

.dark-theme .success-subtext {
  color: #a0aec0;
}

.dark-theme .stat-item {
  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);
  border-color: #4a5568;
}

.dark-theme .stat-number {
  color: #3bbedb;
}

.dark-theme .stat-label {
  color: #a0aec0;
}

.dark-theme .success-footer {
  border-color: #4a5568;
}

/* Адаптивность */
@media (max-width: 768px) {
  .success-stats {
    flex-direction: column;
    gap: 1rem;
  }
  
  .success-footer {
    flex-direction: column;
  }
  
  .success-header h3 {
    font-size: 1.5rem;
  }
  
  .success-text {
    font-size: 1.1rem;
  }
}

/* Стили для всплывашки дублирования шага */
.duplicate-alert {
  position: fixed;
  top: 30px;
  right: 30px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  max-width: 350px;
  animation: fadeInUp 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
  backdrop-filter: blur(10px);
  transform-origin: center;
}

.alert-content {
  display: flex;
  align-items: flex-start;
  padding: 1rem;
  gap: 0.75rem;
}

.alert-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
  margin-top: 0.1rem;
}

.alert-text {
  flex: 1 1;
}

.alert-text h4 {
  margin: 0 0 0.3rem 0;
  font-size: 1rem;
  font-weight: 600;
  color: #2d3748;
}

.alert-text p {
  margin: 0;
  font-size: 0.9rem;
  color: #4a5568;
  line-height: 1.4;
}

.alert-close {
  background: none;
  border: none;
  color: #a0aec0;
  font-size: 1.2rem;
  cursor: pointer;
  padding: 0.2rem;
  border-radius: 4px;
  transition: all 0.2s ease;
  flex-shrink: 0;
  margin-top: -0.2rem;
}

.alert-close:hover {
  background: #f7fafc;
  color: #4a5568;
}

/* Темная тема для всплывашки */
.dark-theme .duplicate-alert {
  background: #2d3748;
  border-color: #4a5568;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
}

.dark-theme .alert-text h4 {
  color: #e2e8f0;
}

.dark-theme .alert-text p {
  color: #a0aec0;
}

.dark-theme .alert-close {
  color: #718096;
}

.dark-theme .alert-close:hover {
  background: #4a5568;
  color: #e2e8f0;
}

/* Анимации для всплывашки */
@keyframes fadeInUp {
  0% {
    transform: translateY(20px) scale(0.9);
    opacity: 0;
  }
  100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

@keyframes fadeOutDown {
  0% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
  100% {
    transform: translateY(20px) scale(0.9);
    opacity: 0;
  }
}

/* Адаптивность для всплывашки */
@media (max-width: 768px) {
  .duplicate-alert {
    top: 20px;
    right: 15px;
    left: 15px;
    max-width: none;
    animation: fadeInUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  }
  
  .alert-content {
    padding: 0.75rem;
  }
  
  .alert-text h4 {
    font-size: 0.95rem;
  }
  
  .alert-text p {
    font-size: 0.85rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/parser/MatricParser.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,eAAe;AACf;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,oCAAoC;EACpC,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,SAAO;AACT;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;;;AAIA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;EAC9C,0CAA0C;EAC1C,wBAAwB;EACxB,6DAA6D;EAC7D,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,gCAAgC;;AAEhC;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,UAAU;EACV,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW,mBAAmB,EAAE;EAChC,MAAM,qBAAqB,EAAE;AAC/B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;EACnB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA,oDAAoD;AACpD;EACE,6DAA6D;EAC7D,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,sBAAsB,EAAE;EAC9B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA,qCAAqC;AACrC;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,yDAAyD;AACzD;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,oDAAoD;AACtD;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kGAAkG;EAClG,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B,wBAAwB,EAAE;EACpD,MAAM,2BAA2B,EAAE;EACnC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,4CAA4C;EAC5C,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,SAAO;EACP,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;EACzC,iBAAiB;EACjB,SAAO;EACP,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,QAAQ;EACR,SAAS;EACT,iDAAiD;AACnD;;AAEA,mDAAmD;AACnD;EACE,UAAU;EACV,iCAAiC;EACjC,oCAAoC;EACpC,iDAAiD;AACnD;;AAEA,mDAAmD;AACnD;EACE,WAAW;EACX,iCAAiC;EACjC,oCAAoC;EACpC,gDAAgD;AAClD;;AAEA,8BAA8B;AAC9B;EACE,6DAA6D;EAC7D,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,+BAA+B;AAC/B;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;;IAEE,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,UAAU;IACV,uCAAuC;EACzC;AACF;;AAEA,iDAAiD;AACjD;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,8CAA8C;EAC9C,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,iCAAiC;IACjC,UAAU;IACV;;;;qBAIiB;EACnB;EACA;IACE,wCAAwC;IACxC,YAAY;IACZ;;;;yBAIqB;EACvB;EACA;IACE,wCAAwC;IACxC,UAAU;IACV;;;;0BAIsB;EACxB;AACF;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,SAAS;EACT,8EAA8E;EAC9E,kBAAkB;EAClB,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,8FAA8F;EAC9F,2BAA2B;AAC7B;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;EAC1C,2CAA2C;EAC3C,gEAAgE;AAClE;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,6DAA6D;EAC7D,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,kGAAkG;EAClG,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,8BAA8B;EAC9B,6BAA6B;EAC7B,2CAA2C;AAC7C;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,mCAAmC;AACnC;EACE,6DAA6D;EAC7D,sCAAsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,gBAAgB;EAChB,0DAA0D;EAC1D,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE;IACE,sCAAsC;IACtC,UAAU;EACZ;EACA;IACE,iCAAiC;IACjC,UAAU;EACZ;AACF;;AAEA;EACE;IACE,iCAAiC;IACjC,UAAU;EACZ;EACA;IACE,sCAAsC;IACtC,UAAU;EACZ;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,SAAS;IACT,WAAW;IACX,UAAU;IACV,eAAe;IACf,0DAA0D;EAC5D;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".parser-container {\r\n  width: 100%;\r\n}\r\n\r\n.parser-header {\r\n  padding-bottom: 1rem;\r\n  border-bottom: 2px solid #e9ecef;\r\n}\r\n\r\n.parser-header h2 {\r\n  color: #333;\r\n  margin: 0 0 0.5rem 0;\r\n  font-size: 1.8rem;\r\n}\r\n\r\n.parser-header p {\r\n  color: #666;\r\n  margin: 0;\r\n  font-size: 1rem;\r\n}\r\n\r\n/* Loading State */\r\n.loading-state {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 3rem;\r\n  color: #666;\r\n}\r\n\r\n.loading-spinner {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 4px solid #f3f3f3;\r\n  border-top: 4px solid #667eea;\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n/* Error State */\r\n.error-state {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 2rem;\r\n  background: #f8d7da;\r\n  color: #721c24;\r\n  border: 1px solid #f5c6cb;\r\n  border-radius: 8px;\r\n  font-weight: 500;\r\n}\r\n\r\n/* Animations */\r\n.parser-container {\r\n  animation: fadeInUp 0.6s ease-out;\r\n}\r\n\r\n@keyframes fadeInUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n/* Dark theme */\r\n.dark-theme .parser-header h2 {\r\n  color: #e9ecef;\r\n}\r\n\r\n.dark-theme .parser-header p {\r\n  color: #adb5bd;\r\n}\r\n\r\n.dark-theme .parser-header {\r\n  border-bottom-color: #495057;\r\n}\r\n\r\n/* Process steps styles */\r\n.add-step-row {\r\n  display: flex;\r\n  justify-content: center;\r\n  margin-bottom: 1.2rem;\r\n}\r\n\r\n.btn.btn-primary {\r\n  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);\r\n  color: #fff;\r\n  border: none;\r\n  padding: 0.6rem 1.4rem;\r\n  border-radius: 8px;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.btn.btn-primary:hover {\r\n  background: linear-gradient(135deg, #2193b0 0%, #667eea 100%);\r\n}\r\n\r\n.process-steps-list {\r\n  margin-top: 2rem;\r\n  background: #f5f7fa;\r\n  border-radius: 12px;\r\n  padding: 1.2rem 1.5rem;\r\n  box-shadow: 0 2px 8px rgba(0,0,0,0.06);\r\n}\r\n\r\n.steps-header {\r\n  /* display: flex; */\r\n  display: grid;\r\n  grid-template-columns: auto auto 1fr;\r\n  align-items: center;\r\n  font-weight: 600;\r\n  margin-bottom: 0.7rem;\r\n  color: #333;\r\n}\r\n\r\n.steps-container {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  gap: 0.5rem;\r\n  margin: 0;\r\n  padding: 0;\r\n  min-height: 60px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.step-item {\r\n  font-size: 1rem;\r\n  color: #222;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  background: #e9ecef;\r\n  border-radius: 6px;\r\n  border: 1px solid #dee2e6;\r\n  padding: 0.5rem 0.8rem;\r\n  padding-right: 25px;\r\n  position: relative;\r\n  min-width: 120px;\r\n  transition: all 0.2s ease;\r\n  cursor: grab;\r\n  user-select: none;\r\n}\r\n\r\n.step-item:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\r\n}\r\n\r\n.step-item:active {\r\n  cursor: grabbing;\r\n}\r\n\r\n.step-content {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n  flex: 1;\r\n}\r\n\r\n.drag-handle {\r\n  color: #999;\r\n  font-size: 0.8rem;\r\n  cursor: grab;\r\n  user-select: none;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.drag-handle:hover {\r\n  color: #667eea;\r\n}\r\n\r\n.step-item:active .drag-handle {\r\n  cursor: grabbing;\r\n}\r\n\r\n.step-code {\r\n  font-weight: 500;\r\n}\r\n\r\n.step-num {\r\n  font-weight: 700;\r\n  margin-right: 0.5rem;\r\n  color: #2193b0;\r\n}\r\n\r\n\r\n\r\n.remove-step-btn {\r\n  position: absolute;\r\n  right: -2px;\r\n  top: -2px;\r\n  background: #dc3545;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 50%;\r\n  width: 18px;\r\n  height: 18px;\r\n  font-size: 10px;\r\n  cursor: pointer;\r\n  opacity: 0;\r\n  transition: all 0.2s ease;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n\r\n.step-item:hover .remove-step-btn {\r\n  opacity: 1;\r\n}\r\n\r\n.step-item.dragging {\r\n  transform: rotate(5deg) scale(1.05) !important;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\r\n  z-index: 1000 !important;\r\n  background: linear-gradient(135deg, #667eea 0%, #2193b0 100%);\r\n  color: white;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.step-item.dragging .step-num {\r\n  color: white;\r\n}\r\n\r\n.step-item.dragging .remove-step-btn {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  color: white;\r\n}\r\n\r\n.step-item.dragging .remove-step-btn:hover {\r\n  background: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.step-item.drag-over {\r\n  border: 2px dashed #667eea;\r\n  background: rgba(102, 126, 234, 0.1);\r\n  transform: scale(1.02);\r\n}\r\n\r\n.remove-step-btn:hover {\r\n  background: #c82333;\r\n  transform: scale(1.1);\r\n}\r\n\r\n/* Анимации для перетаскивания */\r\n\r\n.steps-container {\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n/* Индикатор места вставки */\r\n.steps-container::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 4px;\r\n  background: #667eea;\r\n  opacity: 0;\r\n  transition: opacity 0.2s ease;\r\n  pointer-events: none;\r\n}\r\n\r\n.steps-container.dragging-over::before {\r\n  opacity: 1;\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 700px) {\r\n  .process-steps-list {\r\n    padding: 0.7rem 0.5rem;\r\n  }\r\n  \r\n  .add-step-row {\r\n    justify-content: center;\r\n  }\r\n  \r\n  .parser-header h2 {\r\n    font-size: 1.5rem;\r\n  }\r\n}\r\n\r\n/* Модальное окно подтверждения */\r\n.modal-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.7);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 10000;\r\n  animation: fadeIn 0.3s ease-out;\r\n}\r\n\r\n.modal-content {\r\n  background: white;\r\n  border-radius: 16px;\r\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\r\n  max-width: 500px;\r\n  width: 90%;\r\n  max-height: 80vh;\r\n  overflow-y: auto;\r\n  animation: slideInUp 0.3s ease-out;\r\n}\r\n\r\n.modal-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 1.5rem 1.5rem 0 1.5rem;\r\n  border-bottom: 1px solid #e9ecef;\r\n}\r\n\r\n.modal-header h3 {\r\n  margin: 0;\r\n  color: #333;\r\n  font-size: 1.3rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.modal-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 1.5rem;\r\n  color: #999;\r\n  cursor: pointer;\r\n  padding: 0.5rem;\r\n  border-radius: 50%;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.modal-close:hover {\r\n  background: #f8f9fa;\r\n  color: #333;\r\n}\r\n\r\n.modal-body {\r\n  padding: 1.5rem;\r\n}\r\n\r\n.confirmation-icon {\r\n  text-align: center;\r\n  font-size: 3rem;\r\n  margin-bottom: 1rem;\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n@keyframes pulse {\r\n  0%, 100% { transform: scale(1); }\r\n  50% { transform: scale(1.1); }\r\n}\r\n\r\n.confirmation-text {\r\n  text-align: center;\r\n  font-size: 1.1rem;\r\n  color: #555;\r\n  margin-bottom: 1.5rem;\r\n  line-height: 1.5;\r\n}\r\n\r\n.steps-summary {\r\n  background: #f8f9fa;\r\n  border-radius: 8px;\r\n  padding: 1rem;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.steps-summary h4 {\r\n  margin: 0 0 0.5rem 0;\r\n  color: #333;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n}\r\n\r\n.steps-preview {\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n}\r\n\r\n.step-preview-item {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  padding: 0.75rem 0;\r\n  border-bottom: 1px solid #e9ecef;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.step-preview-item:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.step-number {\r\n  background: #667eea;\r\n  color: white;\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 0.8rem;\r\n  font-weight: 600;\r\n  flex-shrink: 0;\r\n  margin-top: 0.1rem;\r\n}\r\n\r\n.step-details {\r\n  flex: 1;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 0.3rem;\r\n}\r\n\r\n.step-detail-row {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.step-detail-label {\r\n  font-weight: 600;\r\n  color: #666;\r\n  font-size: 0.85rem;\r\n  min-width: 70px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.step-detail-value {\r\n  color: #333;\r\n  font-size: 0.9rem;\r\n  font-weight: 500;\r\n}\r\n\r\n.step-code {\r\n  color: #2193b0;\r\n  font-weight: 600;\r\n  font-family: 'Courier New', monospace;\r\n  font-size: 0.9rem;\r\n  background: #f8f9fa;\r\n  padding: 0.2rem 0.4rem;\r\n  border-radius: 4px;\r\n  border: 1px solid #e9ecef;\r\n}\r\n\r\n.modal-footer {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 1rem;\r\n  padding: 1rem 1.5rem 1.5rem 1.5rem;\r\n  border-top: 1px solid #e9ecef;\r\n}\r\n\r\n.modal-footer .btn {\r\n  padding: 0.75rem 1.5rem;\r\n  border-radius: 8px;\r\n  font-weight: 600;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.modal-footer .btn:hover {\r\n  transform: translateY(-1px);\r\n}\r\n\r\n/* Темная тема для модального окна */\r\n.dark-theme .modal-content {\r\n  background: #2d2d2d;\r\n  color: white;\r\n}\r\n\r\n.dark-theme .modal-header h3 {\r\n  color: white;\r\n}\r\n\r\n.dark-theme .modal-close {\r\n  color: #ccc;\r\n}\r\n\r\n.dark-theme .modal-close:hover {\r\n  background: #3d3d3d;\r\n  color: white;\r\n}\r\n\r\n.dark-theme .confirmation-text {\r\n  color: #ccc;\r\n}\r\n\r\n.dark-theme .steps-summary {\r\n  background: #3d3d3d;\r\n}\r\n\r\n.dark-theme .steps-summary h4 {\r\n  color: white;\r\n}\r\n\r\n.dark-theme .step-detail-label {\r\n  color: #a0aec0;\r\n}\r\n\r\n.dark-theme .step-detail-value {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .step-code {\r\n  color: #64d8e6;\r\n  background: #4a5568;\r\n  border-color: #667788;\r\n}\r\n\r\n.dark-theme .modal-header,\r\n.dark-theme .modal-footer {\r\n  border-color: #555;\r\n}\r\n\r\n.dark-theme .step-preview-item {\r\n  border-color: #555;\r\n}\r\n\r\n/* Анимации для модального окна */\r\n@keyframes slideInUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(30px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n/* Темная тема для process-steps-list */\r\n.dark-theme .process-steps-list {\r\n  background: #2d2d2d;\r\n  border: 1px solid #4a5568;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.dark-theme .steps-header {\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .step-item {\r\n  background: #3d3d3d;\r\n  border: 1px solid #4a5568;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .step-item:hover {\r\n  background: #4a5568;\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .step-num {\r\n  color: #667eea;\r\n}\r\n\r\n.dark-theme .drag-handle {\r\n  color: #a0aec0;\r\n}\r\n\r\n.dark-theme .drag-handle:hover {\r\n  color: #667eea;\r\n}\r\n\r\n.dark-theme .step-item.dragging {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .step-item.dragging .step-num {\r\n  color: #ffffff;\r\n}\r\n\r\n.dark-theme .step-item.drag-over {\r\n  border: 2px dashed #667eea;\r\n  background: rgba(102, 126, 234, 0.2);\r\n} \r\n\r\n/* Добавляем стили для предупреждения о блокировке */\r\n.lock-warning {\r\n  background: linear-gradient(135deg, #fed7d7 0%, #feb2b2 100%);\r\n  border: 2px solid #fc8181;\r\n  border-radius: 8px;\r\n  padding: 1rem;\r\n  margin: 1rem 0;\r\n  text-align: center;\r\n  color: #c53030;\r\n  font-weight: 600;\r\n  animation: pulse 2s infinite;\r\n}\r\n\r\n.dark-theme .lock-warning {\r\n  background: linear-gradient(135deg, #742a2a 0%, #9b2c2c 100%);\r\n  border-color: #fc8181;\r\n  color: #fed7d7;\r\n}\r\n\r\n@keyframes pulse {\r\n  0% { transform: scale(1); }\r\n  50% { transform: scale(1.02); }\r\n  100% { transform: scale(1); }\r\n}\r\n\r\n/* Стили для заблокированных кнопок */\r\n.btn:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n  transform: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n/* Стили для заблокированных элементов в DraggableSteps */\r\n.step-item.locked {\r\n  opacity: 0.7;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.step-item.locked .remove-step-btn {\r\n  display: none;\r\n}\r\n\r\n.step-item.locked .drag-handle {\r\n  cursor: not-allowed;\r\n} \r\n\r\n/* Анимированная подсказка */\r\n.animated-tooltip {\r\n  filter: drop-shadow(0 10px 25px rgba(0, 0, 0, 0.15));\r\n}\r\n\r\n.tooltip-content {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  border-radius: 12px;\r\n  padding: 0;\r\n  min-width: 280px;\r\n  max-width: 320px;\r\n  position: relative;\r\n  overflow: hidden;\r\n  border: 1px solid rgba(255, 255, 255, 0.2);\r\n  backdrop-filter: blur(10px);\r\n}\r\n\r\n.tooltip-content::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);\r\n  animation: shimmer 2s infinite;\r\n  pointer-events: none;\r\n}\r\n\r\n@keyframes shimmer {\r\n  0% { transform: translateX(-100%); }\r\n  100% { transform: translateX(100%); }\r\n}\r\n\r\n.tooltip-header {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  padding: 12px 16px;\r\n  border-bottom: 1px solid rgba(255, 255, 255, 0.2);\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n}\r\n\r\n.tooltip-icon {\r\n  font-size: 16px;\r\n  animation: bounce 2s infinite;\r\n}\r\n\r\n@keyframes bounce {\r\n  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }\r\n  40% { transform: translateY(-3px); }\r\n  60% { transform: translateY(-2px); }\r\n}\r\n\r\n.tooltip-title {\r\n  color: white;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.tooltip-body {\r\n  padding: 16px;\r\n  background: rgba(255, 255, 255, 0.95);\r\n  border-radius: 0 0 12px 12px;\r\n}\r\n\r\n.tooltip-row {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: flex-start;\r\n  margin-bottom: 8px;\r\n  padding: 4px 0;\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.tooltip-row:hover {\r\n  background: rgba(102, 126, 234, 0.05);\r\n  border-radius: 6px;\r\n  padding: 4px 8px;\r\n  margin: 0 -8px 8px -8px;\r\n}\r\n\r\n.tooltip-row:last-child {\r\n  margin-bottom: 0;\r\n  border-bottom: none;\r\n}\r\n\r\n.tooltip-label {\r\n  color: #495057;\r\n  font-weight: 600;\r\n  font-size: 12px;\r\n  min-width: 80px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.tooltip-value {\r\n  color: #2193b0;\r\n  font-weight: 500;\r\n  font-size: 12px;\r\n  text-align: right;\r\n  flex: 1;\r\n  margin-left: 12px;\r\n  word-break: break-word;\r\n}\r\n\r\n.tooltip-code {\r\n  color: #e83e8c;\r\n  font-family: 'Courier New', monospace;\r\n  font-weight: 600;\r\n  font-size: 11px;\r\n  background: rgba(232, 62, 140, 0.1);\r\n  padding: 2px 6px;\r\n  border-radius: 4px;\r\n  border: 1px solid rgba(232, 62, 140, 0.2);\r\n  text-align: right;\r\n  flex: 1;\r\n  margin-left: 12px;\r\n  word-break: break-all;\r\n}\r\n\r\n.tooltip-arrow {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  width: 0;\r\n  height: 0;\r\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\r\n}\r\n\r\n/* Стрелка для подсказки справа (указывает влево) */\r\n.arrow-left {\r\n  left: -8px;\r\n  border-top: 8px solid transparent;\r\n  border-bottom: 8px solid transparent;\r\n  border-right: 8px solid rgba(255, 255, 255, 0.95);\r\n}\r\n\r\n/* Стрелка для подсказки слева (указывает вправо) */\r\n.arrow-right {\r\n  right: -8px;\r\n  border-top: 8px solid transparent;\r\n  border-bottom: 8px solid transparent;\r\n  border-left: 8px solid rgba(255, 255, 255, 0.95);\r\n}\r\n\r\n/* Темная тема для подсказки */\r\n.dark-theme .tooltip-content {\r\n  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);\r\n  border-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.dark-theme .tooltip-header {\r\n  background: rgba(255, 255, 255, 0.05);\r\n  border-bottom-color: rgba(255, 255, 255, 0.1);\r\n}\r\n\r\n.dark-theme .tooltip-body {\r\n  background: rgba(45, 55, 72, 0.95);\r\n}\r\n\r\n.dark-theme .tooltip-label {\r\n  color: #a0aec0;\r\n}\r\n\r\n.dark-theme .tooltip-value {\r\n  color: #3bbedb;\r\n}\r\n\r\n.dark-theme .tooltip-code {\r\n  color: #f687b3;\r\n  background: rgba(246, 135, 179, 0.1);\r\n  border-color: rgba(246, 135, 179, 0.2);\r\n}\r\n\r\n.dark-theme .tooltip-row:hover {\r\n  background: rgba(59, 190, 219, 0.1);\r\n}\r\n\r\n.dark-theme .arrow-left {\r\n  border-right-color: rgba(45, 55, 72, 0.95);\r\n}\r\n\r\n.dark-theme .arrow-right {\r\n  border-left-color: rgba(45, 55, 72, 0.95);\r\n}\r\n\r\n/* Адаптивность для подсказки */\r\n@media (max-width: 768px) {\r\n  .tooltip-content {\r\n    min-width: 240px;\r\n    max-width: 280px;\r\n  }\r\n  \r\n  .tooltip-row {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .tooltip-value,\r\n  .tooltip-code {\r\n    text-align: left;\r\n    margin-left: 0;\r\n  }\r\n}\r\n\r\n/* Анимации появления/исчезновения */\r\n@keyframes tooltipFadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px) scale(0.95);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n@keyframes tooltipFadeOut {\r\n  from {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n  to {\r\n    opacity: 0;\r\n    transform: translateY(10px) scale(0.95);\r\n  }\r\n}\r\n\r\n/* Улучшенные стили для step-item при наведении */\r\n.step-item:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.2);\r\n  border-color: #667eea;\r\n}\r\n\r\n.step-item:hover .step-code {\r\n  color: #667eea;\r\n  font-weight: 600;\r\n}\r\n\r\n/* Темная тема для hover эффектов */\r\n.dark-theme .step-item:hover {\r\n  box-shadow: 0 6px 20px rgba(59, 190, 219, 0.3);\r\n  border-color: #3bbedb;\r\n}\r\n\r\n.dark-theme .step-item:hover .step-code {\r\n  color: #3bbedb;\r\n} \r\n\r\n/* Анимация фейрверка */\r\n.fireworks-container {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  pointer-events: none;\r\n  z-index: 9999;\r\n  overflow: hidden;\r\n}\r\n\r\n.firework {\r\n  position: absolute;\r\n  width: 4px;\r\n  height: 4px;\r\n  border-radius: 50%;\r\n  animation: firework 2s ease-out infinite;\r\n}\r\n\r\n.firework-1 {\r\n  left: 20%;\r\n  top: 60%;\r\n  background: #ff6b6b;\r\n  animation-delay: 0s;\r\n}\r\n\r\n.firework-2 {\r\n  left: 40%;\r\n  top: 40%;\r\n  background: #4ecdc4;\r\n  animation-delay: 0.3s;\r\n}\r\n\r\n.firework-3 {\r\n  left: 60%;\r\n  top: 50%;\r\n  background: #45b7d1;\r\n  animation-delay: 0.6s;\r\n}\r\n\r\n.firework-4 {\r\n  left: 80%;\r\n  top: 30%;\r\n  background: #96ceb4;\r\n  animation-delay: 0.9s;\r\n}\r\n\r\n.firework-5 {\r\n  left: 30%;\r\n  top: 70%;\r\n  background: #feca57;\r\n  animation-delay: 1.2s;\r\n}\r\n\r\n.firework-6 {\r\n  left: 70%;\r\n  top: 60%;\r\n  background: #ff9ff3;\r\n  animation-delay: 1.5s;\r\n}\r\n\r\n.firework-7 {\r\n  left: 50%;\r\n  top: 80%;\r\n  background: #54a0ff;\r\n  animation-delay: 1.8s;\r\n}\r\n\r\n.firework-8 {\r\n  left: 10%;\r\n  top: 50%;\r\n  background: #5f27cd;\r\n  animation-delay: 2.1s;\r\n}\r\n\r\n@keyframes firework {\r\n  0% {\r\n    transform: translateY(0) scale(1);\r\n    opacity: 1;\r\n    box-shadow: \r\n      0 0 0 0 #ff6b6b,\r\n      0 0 0 0 #4ecdc4,\r\n      0 0 0 0 #45b7d1,\r\n      0 0 0 0 #96ceb4;\r\n  }\r\n  50% {\r\n    transform: translateY(-100px) scale(1.5);\r\n    opacity: 0.8;\r\n    box-shadow: \r\n      0 -20px 0 0 #ff6b6b,\r\n      0 -40px 0 0 #4ecdc4,\r\n      0 -60px 0 0 #45b7d1,\r\n      0 -80px 0 0 #96ceb4;\r\n  }\r\n  100% {\r\n    transform: translateY(-200px) scale(0.1);\r\n    opacity: 0;\r\n    box-shadow: \r\n      0 -40px 0 0 #ff6b6b,\r\n      0 -80px 0 0 #4ecdc4,\r\n      0 -120px 0 0 #45b7d1,\r\n      0 -160px 0 0 #96ceb4;\r\n  }\r\n}\r\n\r\n/* Кнопка с эффектом фейрверка */\r\n.fireworks-trigger {\r\n  position: relative;\r\n  overflow: hidden;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.fireworks-trigger::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  width: 0;\r\n  height: 0;\r\n  background: radial-gradient(circle, rgba(255,255,255,0.8) 0%, transparent 70%);\r\n  border-radius: 50%;\r\n  transform: translate(-50%, -50%);\r\n  transition: all 0.5s ease;\r\n}\r\n\r\n.fireworks-trigger:hover::before {\r\n  width: 300px;\r\n  height: 300px;\r\n}\r\n\r\n/* Модалка успеха */\r\n.success-overlay {\r\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.9) 0%, rgba(118, 75, 162, 0.9) 100%);\r\n  backdrop-filter: blur(10px);\r\n}\r\n\r\n.success-modal {\r\n  background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);\r\n  border: 2px solid rgba(102, 126, 234, 0.3);\r\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\r\n  animation: successModalSlideIn 0.6s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n@keyframes successModalSlideIn {\r\n  0% {\r\n    opacity: 0;\r\n    transform: translateY(-50px) scale(0.9);\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n    transform: translateY(0) scale(1);\r\n  }\r\n}\r\n\r\n.success-header {\r\n  text-align: center;\r\n  padding: 2rem 2rem 1rem 2rem;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  border-radius: 12px 12px 0 0;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.success-header::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);\r\n  animation: shimmer 2s infinite;\r\n}\r\n\r\n.success-icon {\r\n  font-size: 4rem;\r\n  margin-bottom: 1rem;\r\n  animation: bounce 1s ease-in-out infinite;\r\n  display: block;\r\n}\r\n\r\n.success-header h3 {\r\n  margin: 0;\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.success-body {\r\n  padding: 2rem;\r\n  text-align: center;\r\n}\r\n\r\n.success-text {\r\n  font-size: 1.3rem;\r\n  font-weight: 600;\r\n  color: #333;\r\n  margin-bottom: 1rem;\r\n  animation: fadeInUp 0.8s ease-out 0.3s both;\r\n}\r\n\r\n.success-subtext {\r\n  font-size: 1rem;\r\n  color: #666;\r\n  margin-bottom: 2rem;\r\n  line-height: 1.6;\r\n  animation: fadeInUp 0.8s ease-out 0.5s both;\r\n}\r\n\r\n@keyframes fadeInUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(20px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n.success-stats {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 3rem;\r\n  margin-bottom: 2rem;\r\n  animation: fadeInUp 0.8s ease-out 0.7s both;\r\n}\r\n\r\n.stat-item {\r\n  text-align: center;\r\n  padding: 1rem;\r\n  border-radius: 12px;\r\n  border: 1px solid #dee2e6;\r\n  min-width: 120px;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.stat-item:hover {\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.2);\r\n}\r\n\r\n.stat-number {\r\n  display: block;\r\n  font-size: 2rem;\r\n  font-weight: 700;\r\n  color: #ffffff;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.stat-label {\r\n  font-size: 0.9rem;\r\n  color: #ffffff;\r\n  font-weight: 500;\r\n}\r\n\r\n.success-footer {\r\n  display: flex;\r\n  justify-content: center;\r\n  gap: 1rem;\r\n  padding: 1.5rem 2rem 2rem 2rem;\r\n  border-top: 1px solid #e9ecef;\r\n  animation: fadeInUp 0.8s ease-out 0.9s both;\r\n}\r\n\r\n.dashboard-btn {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  border: none;\r\n  padding: 0.75rem 1.5rem;\r\n  font-weight: 600;\r\n  font-size: 1rem;\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.dashboard-btn::before {\r\n  content: '';\r\n  position: absolute;\r\n  top: 0;\r\n  left: -100%;\r\n  width: 100%;\r\n  height: 100%;\r\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);\r\n  transition: left 0.5s ease;\r\n}\r\n\r\n.dashboard-btn:hover::before {\r\n  left: 100%;\r\n}\r\n\r\n.dashboard-btn:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 10px 25px rgba(102, 126, 234, 0.4);\r\n}\r\n\r\n/* Темная тема для модалки успеха */\r\n.dark-theme .success-modal {\r\n  background: linear-gradient(135deg, #2d3748 0%, #4a5568 100%);\r\n  border-color: rgba(102, 126, 234, 0.5);\r\n}\r\n\r\n.dark-theme .success-text {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .success-subtext {\r\n  color: #a0aec0;\r\n}\r\n\r\n.dark-theme .stat-item {\r\n  background: linear-gradient(135deg, #4a5568 0%, #2d3748 100%);\r\n  border-color: #4a5568;\r\n}\r\n\r\n.dark-theme .stat-number {\r\n  color: #3bbedb;\r\n}\r\n\r\n.dark-theme .stat-label {\r\n  color: #a0aec0;\r\n}\r\n\r\n.dark-theme .success-footer {\r\n  border-color: #4a5568;\r\n}\r\n\r\n/* Адаптивность */\r\n@media (max-width: 768px) {\r\n  .success-stats {\r\n    flex-direction: column;\r\n    gap: 1rem;\r\n  }\r\n  \r\n  .success-footer {\r\n    flex-direction: column;\r\n  }\r\n  \r\n  .success-header h3 {\r\n    font-size: 1.5rem;\r\n  }\r\n  \r\n  .success-text {\r\n    font-size: 1.1rem;\r\n  }\r\n}\r\n\r\n/* Стили для всплывашки дублирования шага */\r\n.duplicate-alert {\r\n  position: fixed;\r\n  top: 30px;\r\n  right: 30px;\r\n  background: white;\r\n  border: 1px solid #e2e8f0;\r\n  border-radius: 12px;\r\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);\r\n  z-index: 1000;\r\n  max-width: 350px;\r\n  animation: fadeInUp 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);\r\n  backdrop-filter: blur(10px);\r\n  transform-origin: center;\r\n}\r\n\r\n.alert-content {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  padding: 1rem;\r\n  gap: 0.75rem;\r\n}\r\n\r\n.alert-icon {\r\n  font-size: 1.5rem;\r\n  flex-shrink: 0;\r\n  margin-top: 0.1rem;\r\n}\r\n\r\n.alert-text {\r\n  flex: 1;\r\n}\r\n\r\n.alert-text h4 {\r\n  margin: 0 0 0.3rem 0;\r\n  font-size: 1rem;\r\n  font-weight: 600;\r\n  color: #2d3748;\r\n}\r\n\r\n.alert-text p {\r\n  margin: 0;\r\n  font-size: 0.9rem;\r\n  color: #4a5568;\r\n  line-height: 1.4;\r\n}\r\n\r\n.alert-close {\r\n  background: none;\r\n  border: none;\r\n  color: #a0aec0;\r\n  font-size: 1.2rem;\r\n  cursor: pointer;\r\n  padding: 0.2rem;\r\n  border-radius: 4px;\r\n  transition: all 0.2s ease;\r\n  flex-shrink: 0;\r\n  margin-top: -0.2rem;\r\n}\r\n\r\n.alert-close:hover {\r\n  background: #f7fafc;\r\n  color: #4a5568;\r\n}\r\n\r\n/* Темная тема для всплывашки */\r\n.dark-theme .duplicate-alert {\r\n  background: #2d3748;\r\n  border-color: #4a5568;\r\n  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);\r\n}\r\n\r\n.dark-theme .alert-text h4 {\r\n  color: #e2e8f0;\r\n}\r\n\r\n.dark-theme .alert-text p {\r\n  color: #a0aec0;\r\n}\r\n\r\n.dark-theme .alert-close {\r\n  color: #718096;\r\n}\r\n\r\n.dark-theme .alert-close:hover {\r\n  background: #4a5568;\r\n  color: #e2e8f0;\r\n}\r\n\r\n/* Анимации для всплывашки */\r\n@keyframes fadeInUp {\r\n  0% {\r\n    transform: translateY(20px) scale(0.9);\r\n    opacity: 0;\r\n  }\r\n  100% {\r\n    transform: translateY(0) scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n@keyframes fadeOutDown {\r\n  0% {\r\n    transform: translateY(0) scale(1);\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    transform: translateY(20px) scale(0.9);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n/* Адаптивность для всплывашки */\r\n@media (max-width: 768px) {\r\n  .duplicate-alert {\r\n    top: 20px;\r\n    right: 15px;\r\n    left: 15px;\r\n    max-width: none;\r\n    animation: fadeInUp 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\r\n  }\r\n  \r\n  .alert-content {\r\n    padding: 0.75rem;\r\n  }\r\n  \r\n  .alert-text h4 {\r\n    font-size: 0.95rem;\r\n  }\r\n  \r\n  .alert-text p {\r\n    font-size: 0.85rem;\r\n  }\r\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
